<template>
  <a-card class="m-display-flex flex-column nowrap">
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Type Tax">
            <a-select
              showSearch
              placeholder="Choose Type Tax"
              @change="handleType"
              v-decorator="[
                'type_ppn',
                { rules: [{ required: true }], initialValue: datasource[0].type_ppn},
              ]"
            >
            <a-select-option key="ppn_dibebaskan" value="ppn_dibebaskan" >PPN Dibebaskan</a-select-option>
            <a-select-option key="ppn_sktd" value="ppn_sktd" >PPN SKTD</a-select-option>
            <a-select-option key="ppn_dipungut" value="ppn_dipungut" >PPN Dipungut</a-select-option>
            <a-select-option key="ppn_memungut" value="ppn_memungut" >PPN Memungut</a-select-option>
            <a-select-option key="ppn_migas" value="ppn_migas" >PPN Migas</a-select-option>
            <a-select-option key="ppn_ekspor" value="ppn_ekspor" >PPN Ekspor</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-if="vis_value_tax" label="Value tax">
            <a-input-number
              v-decorator="[
                'value_tax',
                {
                  rules: [{ required: true }],
                  initialValue: datasource[0].value_tax,
                },
              ]"
              :formatter="
                (value) =>
                  `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(curReplace, '')"
              :min="0"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
          <a-form-item label="Upload Tax Document" v-if="vis_upload_tax">
              <a-upload
                :showUploadList="true"
                :file-list="push"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                v-decorator="[
                  'upload_document_tax',
                  { rules: [{ required: true, validator: validateStatusUpload }], valuePropName: 'push' },
                ]"
              >
                <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
              </a-upload>
            </a-form-item>
          <!-- <a-form-item label="PPN SKTD">
            <a-input-number
              v-decorator="['ppn_sktd', { rules: [{ required: true }],
                initialValue: datasource[0].ppn_sktd }]"
              :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(curReplace, '')"
              :min="0"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
          <a-form-item label="PPN Dipungut">
            <a-input-number
              v-decorator="['ppn_dipungut', { rules: [{ required: true }],
              initialValue: datasource[0].ppn_dipungut }]"
              :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(curReplace, '')"
              :min="0"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item> -->
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <!-- <a-form-item label="PPN Memungut">
            <a-input-number
              v-decorator="['ppn_memungut', { rules: [{ required: true }],
              initialValue: datasource[0].ppn_memungut }]"
              :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(curReplace, '')"
              :min="0"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item>
          <a-form-item label="PPN Migas">
            <a-input-number
              v-decorator="['ppn_migas', { rules: [{ required: true }],
              initialValue: datasource[0].ppn_migas }]"
              :formatter="(value) => `${initCUr} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="(value) => value.replace(curReplace, '')"
              :min="0"
              class="m-width-full m-text-align right"
            ></a-input-number>
          </a-form-item> -->
        </a-col>
      </a-row>
    </a-form>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";

export default {
  name: "detailInvoice",
  props: {
    detil_invoice: {},
    currency: String
  },
  mixins: [GlobalMethod,CurrencyFormat],
  components: {
  },
  data() {
    return {
      postData: new FormData(),
      datasource : this.detil_invoice,
      vis_value_tax: false,
      vis_upload_tax: true,
      push:[],
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat",]),
    curReplace(){
      return eval("/\\"+this.symbolCurrencyES6(this.currency,1)+"\\s?|(,*)/g")
    },
    initCUr(){
      return this.symbolCurrencyES6(this.currency,0)
    }
  },
  mounted(){
    if(this.datasource[0].type_ppn=='ppn_ekspor'){
        this.vis_value_tax = false;
      }else{
        this.vis_value_tax = true;
      }
    if(this.datasource[0].upload_document_tax && this.datasource[0].upload_document_tax!='No File Uploaded')
      this.convertfiles(this.datasource[0].upload_document_tax, this.datasource[0].path_upload_document_tax, this.datasource[0].tax_files)

    if (this.datasource[0].type_ppn == 'null') {
      this.vis_value_tax = false;
      this.vis_upload_tax = false;
    } else {
      this.vis_upload_tax = true;
    }
  },
  created() {
  },
  methods: {
    moment,
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
       
        values.push = this.push[0];
        Event.$emit("emitChild", {
            detil_invoice: values
        });
      });
    },
    validateStatusUpload(rule, value, callback) {
      if (!this.vis_upload_tax || (this.vis_upload_tax && this.push.length > 0)) {
        callback();
        return;
      }
      callback("File upload can't be empty!");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.push = [file];
        //this.form.resetFields();
        return false;
      }
    },
    handleRemove() {
      this.push = [];
    },
    handleType(val){
      this.datasource.value_tax=0;
      if(val=='ppn_ekspor'){
        this.vis_value_tax = false;
        this.push = [];
      }else{
        this.vis_value_tax = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
            value_tax: null,
          });
        });
        this.push = [];
      }
      this.vis_upload_tax = true;

      if (val == 'null') {
        this.vis_upload_tax = false;
        this.vis_value_tax = false;
      }
    },
    convertfiles(file_name,url,file64){
      let typefile = file_name.substr(file_name.lastIndexOf("."));
          
          if (typefile == ".xls"){
            typefile = "data:application/vnd.ms-excel;base64,";
          } else if(typefile == ".xlsx"){
            typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
          } else if(typefile == ".doc"){
            typefile = "data:application/msword;base64,";
          } else if(typefile == ".docx"){
            typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
          } else if(typefile == ".pdf"){
            typefile = "data:application/pdf;base64,";
          } else if(typefile == ".jpeg" || typefile == ".jpg"){
            typefile = "data:image/jpeg;base64,";
          } else if(typefile == ".png"){
            typefile = "data:image/png;base64,";
          }

          var file = this.dataURLtoFile(
            typefile + file64,
            file_name
          );
          file.uid = "vc-upload-1-1";
          file.status = "done";
          file.exist = true;
          file.url = this.$serviceUrl + url;
          this.push=[file];
    }
  },
  beforeDestroy() {
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style>
</style>